import { useState, useEffect } from 'react';
import api from 'utils/api';
import useDeepCompare from 'effects/useDeepCompare';
import useTixlySession from 'effects/useTixlySession';

interface ProgramData {
  id: unknown;
  purchased?: boolean;
  [key: string]: unknown;
}

interface DataOptions {
  itixUrl: string;
  dataAction?: string;
}

export default ({ itixUrl, dataAction }: DataOptions) => {
  const {
    client: { saved, programs },
  } = useTixlySession(itixUrl);
  const [data, setData] = useState<ProgramData | null>(null);
  const [status, setStatus] = useState<number | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    if (dataAction) {
      timeout = setTimeout(() => {
        setStatus(null);
        setMessage(null);
        api<ProgramData>(dataAction)
          .then(data => {
            setData(data);
            setStatus(200);
          })
          .catch(({ error, status }) => {
            setStatus(status);
            setMessage(error ?? 'unknown');
          });
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [dataAction, saved]);

  useEffect(() => {
    if (data && !data.purchased && programs.length) {
      setData({
        ...data,
        purchased: programs.indexOf(data.id) > -1,
      });
    }
  }, [useDeepCompare(data), useDeepCompare(programs)]);

  return [data, status, message];
};
